class HeroMedia {
  constructor(hero) {
    this.hero = hero;
    this.breakpoint = window.matchMedia('(max-width: 749px)');
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onChange = () => this.update();
    this.breakpoint.addEventListener('change', this.onChange);
    this.reduced.addEventListener('change', this.onChange);
    this.update();
  }
  update() {
    const desktop = this.hero.querySelector('[data-hero-source="desktop"]');
    const mobile = this.hero.querySelector('[data-hero-source="mobile"]');
    const fallback = this.hero.querySelector('[data-hero-fallback]');
    const active = this.breakpoint.matches ? (mobile || desktop) : (desktop || mobile);
    this.hero.querySelectorAll('[data-hero-source]').forEach((source) => { source.hidden = source !== active; });
    if (fallback) fallback.hidden = Boolean(active);
    this.hero.querySelectorAll('video').forEach((video) => { video.pause(); video.preload = 'none'; });
    this.hero.dataset.activeSource = active?.dataset.heroSource || 'fallback';
    if (!active || active.dataset.heroKind !== 'video' || this.reduced.matches || document.documentElement.classList.contains('motion-reduced')) return;
    const video = active.querySelector('video');
    if (!video) return;
    video.preload = 'metadata';
    video.play().catch(() => {});
  }
  destroy() {
    this.breakpoint.removeEventListener('change', this.onChange);
    this.reduced.removeEventListener('change', this.onChange);
    this.hero.querySelectorAll('video').forEach((video) => video.pause());
  }
}
const heroControllers = new WeakMap();
function mountHero(hero) {
  if (heroControllers.has(hero)) return;
  heroControllers.set(hero, new HeroMedia(hero));
}
function mountWithin(root) {
  if (root.nodeType !== 1) return;
  if (root.matches('[data-home-hero]')) mountHero(root);
  root.querySelectorAll?.('[data-home-hero]').forEach(mountHero);
}
function destroyWithin(root) {
  if (root.nodeType !== 1) return;
  const heroes = root.matches('[data-home-hero]') ? [root] : [...root.querySelectorAll?.('[data-home-hero]') || []];
  heroes.forEach((hero) => { heroControllers.get(hero)?.destroy(); heroControllers.delete(hero); });
}
document.querySelectorAll('[data-home-hero]').forEach(mountHero);
document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
new MutationObserver((records) => records.forEach((record) => {
  record.addedNodes.forEach(mountWithin);
  record.removedNodes.forEach(destroyWithin);
})).observe(document.documentElement, { childList: true, subtree: true });
